import { PageHeading } from "@via/components/page-heading.tsx";
import { HorizontalTabs } from "@via/components/tabs.tsx";
import { PAGE_NAMES, ROUTES } from "@via/utils/constants.tsx";
import { getCortexTabs } from "@via/utils/constants.tsx";
import { type JSX, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@via/hooks/useAuth.tsx";
import { SocketProvider } from "@via/context/socket-context";
import { SOCKET_URI } from "@via/pages/projects/pipelines/pipeline";

export default function Cortex(): JSX.Element {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      user !== null &&
      user !== false &&
      user?.featureFlags &&
      !user.featureFlags.FF_MODEL_SMITH
    ) {
      navigate(ROUTES.NOT_FOUND);
    }
  }, [user, navigate]);

  const cortexTabs = getCortexTabs(
    user?.featureFlags?.FF_DISPLAY_DEMO_DATA ?? false
  );
  return (
    <main className="via-content-wrapper">
      <div className="via-page-heading-wrapper">
        <PageHeading title={PAGE_NAMES.CORTEX} />
      </div>
      <SocketProvider socketUri={SOCKET_URI}>
        <HorizontalTabs buttonIdPrefix="cortex" options={cortexTabs} />
        <Outlet />
      </SocketProvider>
    </main>
  );
}
